import { IProduktdefinition } from "./IProduktdefinition";
export class ProduktdefinitionRestriktioner {
    apteringsvillkor: boolean;
    begransningsinstallningar: boolean;
    begransningsmatris: boolean;
    diameterinstallningar: boolean;
    fargmarkning: boolean;
    fordelningsinstallningar: boolean;
    fordelningsmatris: boolean;
    kapfonster: boolean;
    kvalitetsinstallningar: boolean;
    langdinstallningar: boolean;
    prisinstallningar: boolean;
    vardematris: boolean;

    constructor(model: IProduktdefinition) {
        this.apteringsvillkor = model.restriktion?.apteringsvillkor;
        this.begransningsinstallningar = model.restriktion?.begransningsinstallningar;
        this.begransningsmatris = model.restriktion?.begransningsmatris;
        this.diameterinstallningar = model.restriktion?.diameterinstallningar;
        this.fargmarkning = model.restriktion?.fargmarkning;
        this.fordelningsinstallningar = model.restriktion?.fordelningsinstallningar;
        this.fordelningsmatris = model.restriktion?.fordelningsmatris;
        this.kapfonster = model.restriktion?.kapfonster;
        this.kvalitetsinstallningar = model.restriktion?.kvalitetsinstallningar;
        this.langdinstallningar = model.restriktion?.langdinstallningar;
        this.prisinstallningar = model.restriktion?.prisinstallningar;
        this.vardematris = model.restriktion?.vardematris;
    }

    mapToDto(model: IProduktdefinition) {
        model.restriktion.apteringsvillkor = this.apteringsvillkor;
        model.restriktion.begransningsinstallningar = this.begransningsinstallningar;
        model.restriktion.begransningsmatris = this.begransningsmatris;
        model.restriktion.diameterinstallningar = this.diameterinstallningar;
        model.restriktion.fargmarkning = this.fargmarkning;
        model.restriktion.fordelningsinstallningar = this.fordelningsinstallningar;
        model.restriktion.fordelningsmatris = this.fordelningsmatris;
        model.restriktion.kapfonster = this.kapfonster;
        model.restriktion.kvalitetsinstallningar = this.kvalitetsinstallningar;
        model.restriktion.langdinstallningar = this.langdinstallningar;
        model.restriktion.prisinstallningar = this.prisinstallningar;
        model.restriktion.vardematris = this.vardematris;
    }
}
